<template>
  <devis-types document-type="facture" />
</template>

<script>
import DevisTypes from "./devisTypes.vue";

export default {
  name: "FactureTypes",
  components: {
    DevisTypes,
  },
};
</script>

